import React from 'react';
import c from 'classnames';
import s from './InputLabelSubText.scss';
const InputLabelSubText = ({ className, children })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: c(s['root'], className)
    }, children);
};
InputLabelSubText.displayName = 'InputLabelSubText';
export default InputLabelSubText;

//# sourceMappingURL=InputLabelSubText.js.map